export const en = {
    'empty-region': 'todo',
    'error-message': 'todo',
    'incorrect-region': 'todo',
    'invalid-client-currency': 'todo',
    'invalid-client-ids': {
        one: 'todo',
        some: 'todo',
        many: 'todo',
        none: 'todo'
    },
    'name-cannot-be-empty': 'todo',
    'name-contain-only-symbols':
        'Title may only contain letters from Latin, Turkish, Russian, Ukrainian, Belarusian, and Kazakh languages as well as numbers and punctuation marks.',
    'name-greater-than-max': 'todo',
    'package-forbidden-to-change': 'todo',
    'price-greater-then-max': 'todo',
    'price-less-then-min': 'todo',
    'show-max-less-then-min': 'todo',
    'show-max-less-then-show-min': 'todo',
    'show-min-less-then-min': 'todo',
    'tracker-url-cannot-be-empty': 'todo',
    'tracker-url-invalid': 'todo',
    'try-later': 'todo'
};
